import {ApKendoIconService} from '../../../icons/ap-kendo-icon.service';

export class ApIcons {
  public static Delete = ApKendoIconService.Get('trashIcon');
  public static Edit = ApKendoIconService.Get('pencilIcon');
  public static Print = ApKendoIconService.Get('printIcon');
  public static Save = ApKendoIconService.Get('saveIcon');
  public static Source = ApKendoIconService.Get('codeIcon');
  public static XLS = ApKendoIconService.Get('fileExcelIcon');
  public static PDF = ApKendoIconService.Get('filePdfIcon');
  public static Shape = ApKendoIconService.Get('shapesIcon');
}
